import React, { useEffect, useRef, useState } from "react";
import $ from "jquery";
import Footer12 from "../shared/Footer12";
import Navbar12 from "../shared/Navbar12";
import Sidebar12 from "../shared/Sidebar12";
import { AnimatePresence, motion } from "framer-motion";
import config from "../../config";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import * as XLSX from "xlsx";
import { FaHandPointRight } from "react-icons/fa6";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import AnnexurePDF12 from "./AnnexurePDF12";
import { pdf } from "@react-pdf/renderer";
import { saveAs } from "file-saver";
import DataTable from "react-data-table-component";
import { MdOutlineKeyboardDoubleArrowRight } from "react-icons/md";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import { MdOutlineKeyboardDoubleArrowLeft } from "react-icons/md";
import { MdOutlineKeyboardArrowLeft, MdCurrencyRupee } from "react-icons/md";
const customStyles = {
  header: {
    style: {
      backgroundColor: "#4a90e2",
      color: "#fff",
      fontSize: "16px",
      fontWeight: "bold",
      minHeight: "56px",
    },
  },
  headRow: {
    style: {
      backgroundColor: "#4a90e2",
      color: "#fff",
    },
  },
  headCells: {
    style: {
      color: "#fff",
      fontWeight: "bold",
      fontSize: "14px",
    },
  },
  rows: {
    style: {
      minHeight: "48px",
      "&:nth-of-type(odd)": {
        backgroundColor: "#f2f2f2",
      },
    },
    highlightOnHoverStyle: {
      backgroundColor: "#d1ecf1",
      borderBottomColor: "#bee5eb",
      outline: "1px solid #bee5eb",
    },
  },
  cells: {
    style: {
      fontSize: "14px",
      padding: "8px",
    },
  },
};

function Challanstatus12() {
  const navigate = useNavigate();

  // const modalRef = useRef(null);
  const iframeRef = useRef(null);
  const iframeRef2 = useRef(null);
  // const tableRef = useRef(null);
  // const tableRef2 = useRef(null);
  const fileInputRef = useRef(null);
  const [challanData, setChallanData] = useState([]);
  const [loading, setLoading] = useState(true);
  // const [isloading, setIsloading] = useState(false);
  const [selectedExamFees, setSelectedExamFees] = useState("");
  const [selectedChallanNo, setSelectedChallanNo] = useState("");
  const token = sessionStorage.getItem("tokenclassxii");
  const [modalData, setModalData] = useState([]);
  const [modalchallan, setModalchallan] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [showModal2, setShowModal2] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(100);

  const [EndDate, setEndDate] = useState("");
  const [regstartdatefinal, setRegstartdatefinal] = useState("");
  const date = new Date();
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  const currentDate = `${day}-${month}-${year}`;

  useEffect(() => {
    document.body.classList.add("sidebar-icon-only");
    return () => {
      document.body.classList.remove("sidebar-icon-only");
    };
  }, []);

  const parseDate = (str) => {
    const [dd, mm, yyyy] = str.split("-");
    return new Date(`${yyyy}-${mm}-${dd}`);
  };

  const [searchQuery, setSearchQuery] = useState("");

  const filteredStudents = challanData.filter((student) => {
    const query = searchQuery.toLowerCase();
    return (
      student.challaN_NO?.toLowerCase().includes(query) ||
      student.exaM_FEES?.toLowerCase().includes(query) ||
      student.latE_FEES?.toLowerCase().includes(query) ||
      student.challaN_DATE?.toLowerCase().includes(query) ||
      student.challaN_TIME?.toLowerCase().includes(query) ||
      student.challaN_NO?.toLowerCase().includes(query) ||
      student.nO_OF_STUDENT?.toLowerCase().includes(query) ||
      student.paymenT_STATUS?.toLowerCase().includes(query) ||
      student.transactioN_DATE_TIME?.toLowerCase().includes(query) ||
      student.fO_STATUS?.toLowerCase().includes(query) ||
      student.fO_REMARKS?.toLowerCase().includes(query) ||
      student.paymenT_MODE?.toLowerCase().includes(query)
    );
  });

  const [formData, setFormData] = useState({
    challanNo: "",
    utrNumber: "",
    paymentDate: "",
    bankName: "",
    amount: "",
    document: null,
  });

  const openModal = (challanNo, examFees, LATE_FEES) => {
    const examAmount = Number(examFees) || 0;
    const lateAmount = Number(LATE_FEES) || 0;
    const totalAmount = examAmount + lateAmount;
    // setOfflineorderid(orderid);
    setSelectedExamFees(totalAmount);
    setSelectedChallanNo(challanNo);
    setFormData((prevFormData) => ({
      ...prevFormData,
      challanNo: challanNo,
      amount: totalAmount,
    }));
    setShowModal2(true);
  };

  const openModal2 = (challanNo) => {
    sessionStorage.setItem("challanNo", challanNo);
    localStorage.setItem("modalOpen", "true");
    $("#pdfModal").addClass("show").css("display", "block");
    $("body")
      .addClass("modal-open")
      .append('<div class="modal-backdrop fade show"></div>');
    const pdfUrl = `/generate-pdf-class-xii`;
    // console.log(pdfUrl);
    if (iframeRef.current) {
      iframeRef.current.src = pdfUrl;
    }
  };

  const closeModal2 = () => {
    localStorage.removeItem("modalOpen");
    $("#pdfModal").removeClass("show").css("display", "none");
    $("body").removeClass("modal-open");
    $(".modal-backdrop").remove();
  };

  const openModal3 = async (challanNo) => {
    sessionStorage.setItem("ChallanNo", challanNo);
    try {
      setLoading(true);
      const response = await axios.post(
        `${config.API_BASE_URL}/GetPrintAnnexureStudentData_CL12`,
        {
          challanNo: challanNo,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setModalData(response.data.data.annexureList);
      setModalchallan(response.data.data?.challanData[0]);
      setShowModal(true);
    } catch (error) {
      console.error("Error fetching modal data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      const token = sessionStorage.getItem("tokenclassxii");

      if (!token) {
        console.error("Missing school Code or token");
        setLoading(false);
        return;
      }

      try {
        const response = await fetch(
          `${config.API_BASE_URL}/GetListChallanStatusBySchool_CL12 `,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }

        const data = await response.json();

        if (!data.data.challanList || data.data.challanList.length === 0) {
          Swal.fire({
            icon: "info",
            title: "No Data Available",
            text: "No challan records found.",
          });
          setChallanData([]);
        } else {
          setChallanData(data.data.challanList);
          setEndDate(
            data.data.paymentEndDate.cL_12_PAYMENT_UPLOAD_END_DATE || ""
          );

          const [day, month, year] =
            data.data.paymentEndDate.cL_12_REGISTRATION_START_DATE.split("-");
          const regstartdateObj = new Date(year, month - 1, day);
          setRegstartdatefinal(regstartdateObj);
          // console.log(data.data);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleInputChange = (e) => {
    const { name, value, type, files } = e.target;

    if (type === "file") {
      const file = files[0];
      if (!file) return;

      // Only allow JPG and JPEG
      const allowedTypes = ["image/jpeg", "image/jpg", "image/png"];
      const minSize = 10 * 1024;
      const maxSize = 100 * 1024;

      if (!allowedTypes.includes(file.type)) {
        toast.error("Only JPG, JPEG & PNG files are allowed.");
        fileInputRef.current.value = "";
        return;
      }

      if (file.size < minSize || file.size > maxSize) {
        toast.error("File size must be between 10KB and 100KB.");
        fileInputRef.current.value = "";
        return;
      }

      setFormData({
        ...formData,
        [name]: file,
      });
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  const handleSubmit = async () => {
    console.log(formData);
    if (
      !formData.challanNo ||
      !formData.utrNumber ||
      !formData.paymentDate ||
      !formData.bankName ||
      !formData.document
    ) {
      toast.warning(
        "All fields are mandatory. Please fill out all required details."
      );
      return;
    }

    try {
      setLoading(true);

      const file = formData.document;

      const allowedTypes = ["image/jpeg", "image/jpg", "image/png"];
      const maxSize = 1024 * 1024;

      if (!allowedTypes.includes(file.type)) {
        toast.error("Only JPG, JPEG and PNG files are allowed.");
        setLoading(false);
        return;
      }

      if (file.size > maxSize) {
        toast.error("File size must be 1MB or smaller.");
        setLoading(false);
        return;
      }

      const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
      };
      const utrNumberUpper = formData.utrNumber.toUpperCase();
      const bankNameUpper = formData.bankName.toUpperCase();
      const submissionData = new FormData();
      submissionData.append("ChallanNo", formData.challanNo);
      submissionData.append("TransactionNumber", utrNumberUpper);
      submissionData.append("PaymentDate", formatDate(formData.paymentDate));
      submissionData.append("BankName", bankNameUpper);
      submissionData.append("ChallanImage", file);

      const token = sessionStorage.getItem("tokenclassxii");

      const response = await fetch(
        `${config.API_BASE_URL}/InsertPaymentData_CL12`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: submissionData,
        }
      );

      if (!response.ok) {
        throw new Error("Failed to submit payment details");
      }

      setLoading(false);
      setShowModal2(false);

      Swal.fire({
        title: "Success",
        text: "Your payment details submitted successfully.",
        icon: "success",
        confirmButtonText: "OK",
      }).then((result) => {
        if (result.isConfirmed) {
          window.location.reload();
        }
      });
    } catch (error) {
      console.error("Error submitting form:", error);
      toast.error("Error submitting form. Please try again.");
      setLoading(false);
    }
  };

  const toBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  const generatePdf = async () => {
    if (!modalData.length) {
      Swal.fire("No Data", "No student data available for export.", "warning");
      return;
    }

    const token = sessionStorage.getItem("tokenclassxii");
    if (!token) {
      Swal.fire(
        "Authentication Error",
        "Token is missing. Please log in.",
        "error"
      );
      return;
    }

    try {
      setLoading(true);

      const now = new Date();
      const formattedDateTime = `${now
        .getDate()
        .toString()
        .padStart(2, "0")}-${(now.getMonth() + 1)
        .toString()
        .padStart(2, "0")}-${now.getFullYear()} ${now
        .getHours()
        .toString()
        .padStart(2, "0")}:${now.getMinutes().toString().padStart(2, "0")}:${now
        .getSeconds()
        .toString()
        .padStart(2, "0")}`;

      const totalFees = modalData.reduce(
        (total, student) =>
          total +
          (parseFloat(student.exaM_FEES) || 0) +
          (parseFloat(student.latE_FEE) || 0),
        0
      );

      const schoolCode = sessionStorage.getItem("schoolCode") || "";
      const schoolName = sessionStorage.getItem("schoolname") || "";

      const doc = (
        <AnnexurePDF12
          modalData={modalData}
          modalchallan={modalchallan}
          schoolCode={schoolCode}
          schoolName={schoolName}
          totalFees={totalFees}
          annexureDateTime={formattedDateTime}
        />
      );

      // Generate PDF as blob
      const asPdf = pdf();
      asPdf.updateContainer(doc);
      const blob = await asPdf.toBlob();

      // Save file
      const fileName = `Annexure_${modalchallan.challaN_NO}.pdf`;
      saveAs(blob, fileName);

      setLoading(false);
      setShowModal(false);

      Swal.fire({
        title: "Success",
        text: "PDF file has been generated successfully!",
        icon: "success",
        timer: 1500,
        showConfirmButton: false,
      });
    } catch (error) {
      console.error("Error generating PDF:", error);

      setLoading(false);

      Swal.fire(
        "Error",
        "An error occurred while generating the PDF.",
        "error"
      );
    }
  };
  const totalPages = Math.ceil(filteredStudents.length / perPage);
  const indexOfLastItem = currentPage * perPage;
  const indexOfFirstItem = indexOfLastItem - perPage;
  const currentItems = filteredStudents.slice(
    indexOfFirstItem,
    indexOfLastItem
  );
  const handlePerPageChange = (e) => {
    setPerPage(Number(e.target.value));
    setCurrentPage(1);
  };
  return (
    <>
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar />
      <div class="container-scroller">
        <Navbar12 />
        {loading && (
          <div className="custom-loader-container">
            <div className="custom-loader"></div>
          </div>
        )}
        <div class="container-fluid page-body-wrapper">
          <Sidebar12 />
          <div class="main-panel">
            <div class="content-wrapper">
              <div class="row">
                <div class="col-md-12 mb-1">
                  <section class="content-header">
                    <h1>
                      <i class="fa fa-user"></i>&nbsp; Challan Status
                    </h1>
                    <ol class="breadcrumb">
                      <li>
                        <a
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            navigate("/class-xii-dashboard");
                          }}
                        >
                          <svg
                            stroke="currentColor"
                            fill="currentColor"
                            stroke-width="0"
                            viewBox="0 0 512 512"
                            height="1em"
                            width="1em"
                            xmlns="http://www.w3.org/2000/svg"
                            style={{ marginTop: "-4px" }}
                          >
                            <path d="M256 64C132.3 64 32 164.2 32 287.9c0 57 21.3 109 56.3 148.5 1.1 1.2 2.1 2.4 3.2 3.5C96.3 445 103 448 110 448c7.1 0 13.8-3 18.6-8.2 31.6-34.4 77-55.9 127.4-55.9s95.8 21.6 127.4 55.9c4.8 5.2 11.5 8.2 18.6 8.2 7 0 13.7-2.9 18.5-8.1 1.1-1.2 2.1-2.3 3.2-3.5 35-39.5 56.3-91.5 56.3-148.5C480 164.2 379.7 64 256 64zm-14 45.9c0-7.7 6.3-14 14-14s14 6.3 14 14v36c0 7.7-6.3 14-14 14s-14-6.3-14-14v-36zm-128 192H78c-7.7 0-14-6.3-14-14s6.3-14 14-14h36c7.7 0 14 6.3 14 14s-6.3 14-14 14zm51.5-104.5c-5.4 5.4-14.4 5.4-19.8 0L120.2 172c-5.4-5.4-5.4-14.4 0-19.8s14.4-5.4 19.8 0l25.5 25.5c5.4 5.4 5.4 14.3 0 19.7zm160.6 34.5l-47.5 75.5c-1.9 2.6-4.3 5.1-7 7-13.5 9.7-32.3 6.5-42-7s-6.5-32.3 7-42l75.5-47.5c3.4-2.4 8.1-2.5 11.7 0 4.5 3.2 5.5 9.5 2.3 14zm40.2-34.5c-5.4 5.4-14.4 5.4-19.8 0s-5.4-14.4 0-19.8l25.5-25.5c5.4-5.4 14.4-5.4 19.8 0s5.4 14.4 0 19.8l-25.5 25.5zM434 301.9h-36c-7.7 0-14-6.3-14-14s6.3-14 14-14h36c7.7 0 14 6.3 14 14s-6.3 14-14 14z"></path>
                          </svg>{" "}
                          Home&nbsp;
                        </a>
                      </li>
                      <li class="active"> Challan Status</li>
                    </ol>
                    <h3></h3>
                  </section>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12 mb-4 stretch-card">
                  <div class="card">
                    <div class="card-body">
                      <div class="row">
                        <div className="col-md-12">
                          <div className="mb-3 d-flex justify-content-end">
                            <input
                              type="text"
                              className="form-control form-control-sm"
                              placeholder="Search students..."
                              value={searchQuery}
                              onChange={(e) => setSearchQuery(e.target.value)}
                              style={{ width: "200px" }}
                            />
                          </div>
                          <div style={{ overflowX: "auto" }}>
                            <table class="table table-bordered table-condensed">
                              <thead>
                                <tr>
                                  <th colSpan="5">Challan Status</th>
                                  <th colSpan="4">Action</th>
                                </tr>
                                <tr className="table-primary">
                                  <th>Sl No.</th>
                                  <th>Challan No.</th>
                                  <th>Challan Date</th>
                                  <th>Challan Time</th>
                                  <th>Annexure/Student List </th>
                                  <th>Payment Status </th>
                                  <th>Pay Now </th>
                                  <th>Accounts Approval Status</th>
                                  <th>Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {filteredStudents.length > 0 ? (
                                  filteredStudents.map((challan, index) => (
                                    <tr key={index}>
                                      <td>{index + 1}</td>
                                      <td>
                                        <p
                                          style={{
                                            fontWeight: "600",
                                            fontSize: "14px",
                                            marginBottom: "2px",
                                          }}
                                        >
                                          {challan.challaN_NO}
                                        </p>
                                        <p
                                          style={{
                                            textWrap: "nowrap",
                                            marginBottom: "2px",
                                          }}
                                        >
                                          <b>
                                            Registration Fees:
                                            <MdCurrencyRupee />
                                          </b>
                                          {challan.exaM_FEES}
                                        </p>
                                        <p style={{ textWrap: "nowrap" }}>
                                          <b>
                                            Late Fees: <MdCurrencyRupee />
                                          </b>
                                          {challan.latE_FEES || 0}
                                        </p>
                                      </td>
                                      <td>{challan.challaN_DATE}</td>
                                      <td>{challan.challaN_TIME}</td>
                                      <td style={{ textAlign: "center" }}>
                                        <button
                                          style={{ whiteSpace: "nowrap" }}
                                          className="btn btn-sm btn-primary"
                                          onClick={() =>
                                            openModal3(challan.challaN_NO)
                                          }
                                        >
                                          {/* <i className="fa fa-print"></i> */}
                                          &nbsp;{challan.nO_OF_STUDENT}
                                        </button>
                                      </td>
                                      <td>
                                        {challan.paymenT_STATUS ===
                                        "COMPLETE" ? (
                                          <span
                                            className="btn btn-success btn-xs"
                                            style={{
                                              fontSize: "12px",
                                              pointerEvents: "none",
                                            }}
                                          >
                                            Completed
                                          </span>
                                        ) : (
                                          <span
                                            className="btn btn-warning btn-xs"
                                            style={{
                                              fontSize: "12px",
                                              pointerEvents: "none",
                                            }}
                                          >
                                            Pending
                                          </span>
                                        )}
                                      </td>
                                      <td>
                                        {challan.paymenT_STATUS ===
                                        "COMPLETE" ? (
                                          <>
                                            <p style={{ marginBottom: "2px" }}>
                                              <b>Payment Status:</b>{" "}
                                              {challan.paymenT_STATUS ===
                                              "COMPLETE"
                                                ? "COMPLETED"
                                                : challan.paymenT_STATUS}
                                            </p>
                                            <p style={{ marginBottom: "2px" }}>
                                              <b>Payment Mode:</b>{" "}
                                              {challan.paymenT_MODE || "N/A"}
                                            </p>
                                            <p>
                                              <b>Transaction Date:</b>{" "}
                                              {challan.transactioN_DATE_TIME ||
                                                "N/A"}
                                            </p>
                                          </>
                                        ) : parseDate(currentDate) >=
                                          parseDate(EndDate) ? (
                                          <button
                                            className="btn btn-danger btn-sm"
                                            disabled
                                          >
                                            <i className="fa fa-ban"></i>
                                            &nbsp;Payment Closed
                                          </button>
                                        ) : (
                                          <div style={{ whiteSpace: "nowrap" }}>
                                            <FaHandPointRight
                                              className="blink-shake"
                                              style={{ fontSize: "20px" }}
                                            />
                                            &nbsp;&nbsp;
                                            <a
                                              style={{
                                                whiteSpace: "nowrap",
                                                marginBottom: "5px",
                                              }}
                                              className="btn btn-success btn-sm text-white"
                                              onClick={() =>
                                                openModal(
                                                  challan.challaN_NO,
                                                  challan.exaM_FEES,
                                                  challan.latE_FEES
                                                )
                                              }
                                            >
                                              Submit NEFT/RTGS Details
                                            </a>
                                            &nbsp;&nbsp;
                                            {/* <a
                                                   style={{
                                                     whiteSpace: "nowrap",
                                                     marginBottom: "5px",
                                                   }}
                                                   className="btn btn-primary btn-sm text-white"
                                                   onClick={() =>
                                                     openModal5(
                                                       challan.CHALLAN_NO,
                                                       challan.NO_OF_STUDENT,
                                                       challan.EXAM_FEES,
                                                       challan.LATE_FEES,
                                                       challan.ORDER_ID
                                                     )
                                                   }
                                                 >
                                                   Online
                                                 </a> */}
                                          </div>
                                        )}
                                      </td>
                                      <td>
                                        {challan.fO_STATUS === "APPROVED" ? (
                                          <span
                                            class="btn btn-success btn-xs"
                                            disabled=""
                                            style={{ pointerEvents: "none" }}
                                          >
                                            Approved
                                          </span>
                                        ) : challan.fO_STATUS === "PENDING" ? (
                                          <span
                                            class="btn btn-warning btn-xs"
                                            disabled=""
                                            style={{ pointerEvents: "none" }}
                                          >
                                            Pending
                                          </span>
                                        ) : (
                                          <div>
                                            <span
                                              class="btn btn-danger btn-xs"
                                              disabled=""
                                              style={{ pointerEvents: "none" }}
                                            >
                                              Rejected
                                            </span>
                                            <p>
                                              <b>Remarks:</b>{" "}
                                              {challan.fO_REMARKS}
                                            </p>
                                          </div>
                                        )}
                                      </td>
                                      <td>
                                        <a
                                          className="btn btn-warning btn-sm text-white"
                                          onClick={() =>
                                            openModal2(challan.challaN_NO)
                                          }
                                          style={{
                                            marginRight: "5px",
                                            cursor: "pointer",
                                            whiteSpace: "nowrap",
                                          }}
                                        >
                                          <i className="fa fa-print"></i>
                                          &nbsp;Re-Print Challan
                                        </a>
                                      </td>
                                    </tr>
                                  ))
                                ) : (
                                  <tr>
                                    <td colSpan="9" className="text-center">
                                      No data found
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                              {/* <tfoot>
                                       <tr>
                                           <td colSpan="13">
                                               <a className="btn btn-sm btn-danger">Submit to DEO&nbsp;<i className="fa fa-arrow-right"></i></a>
                                           </td>
                                       </tr>
                                   </tfoot> */}
                            </table>
                          </div>
                        </div>
                        <div className="d-flex justify-content-between align-items-center mt-3">
                          <div>
                            Showing {(currentPage - 1) * perPage + 1} to{" "}
                            {Math.min(indexOfLastItem, filteredStudents.length)}{" "}
                            of {filteredStudents.length} entries
                          </div>
                          <div className="d-flex align-items-center gap-2">
                            <MdOutlineKeyboardDoubleArrowLeft
                              onClick={() => {
                                if (currentPage > 1) setCurrentPage(1);
                              }}
                              style={{
                                cursor:
                                  currentPage > 1 ? "pointer" : "not-allowed",
                                opacity: currentPage > 1 ? 1 : 0.5,
                              }}
                            />

                            <MdOutlineKeyboardArrowLeft
                              onClick={() => {
                                if (currentPage > 1)
                                  setCurrentPage((prev) => prev - 1);
                              }}
                              style={{
                                cursor:
                                  currentPage > 1 ? "pointer" : "not-allowed",
                                opacity: currentPage > 1 ? 1 : 0.5,
                              }}
                            />

                            <span>
                              Page {currentPage} of {totalPages}
                            </span>

                            <MdOutlineKeyboardArrowRight
                              onClick={() => {
                                if (currentPage < totalPages)
                                  setCurrentPage((prev) => prev + 1);
                              }}
                              style={{
                                cursor:
                                  currentPage < totalPages
                                    ? "pointer"
                                    : "not-allowed",
                                opacity: currentPage < totalPages ? 1 : 0.5,
                              }}
                            />

                            <MdOutlineKeyboardDoubleArrowRight
                              onClick={() => {
                                if (currentPage < totalPages)
                                  setCurrentPage(totalPages);
                              }}
                              style={{
                                cursor:
                                  currentPage < totalPages
                                    ? "pointer"
                                    : "not-allowed",
                                opacity: currentPage < totalPages ? 1 : 0.5,
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <AnimatePresence>
              {showModal && (
                <motion.div
                  className="modal-backdrop"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100vw",
                    height: "100vh",
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    backdropFilter: "blur(8px)",
                    WebkitBackdropFilter: "blur(8px)",
                    zIndex: 1100,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <motion.div
                    initial={{ scale: 0.8, opacity: 0 }}
                    animate={{ scale: 1, opacity: 1 }}
                    exit={{ scale: 0.8, opacity: 0 }}
                    transition={{ duration: 0.3 }}
                    style={{
                      background: "#fff",
                      borderRadius: "12px",
                      width: "95%",
                      maxWidth: "1200px",
                      position: "relative",
                      display: "flex",
                      flexDirection: "column",
                      maxHeight: "90vh",
                    }}
                  >
                    <div
                      className="bg-primary"
                      style={{
                        color: "white",
                        padding: "15px 30px",
                        borderBottom: "1px solid #ddd",
                        fontWeight: "bold",
                        fontSize: "18px",
                        position: "relative",
                      }}
                    >
                      <h5 className="modal-title">
                        Challan No : {modalchallan.challaN_NO}
                        <br />
                        Challan Date : {modalchallan.challaN_ENTRY_DATE}
                        <br />
                        Challan Time : {modalchallan.challaN_ENTRY_TIME}
                      </h5>
                      <button
                        type="button"
                        onClick={() => setShowModal(false)}
                        style={{
                          color: "white",
                          position: "absolute",
                          top: "10px",
                          right: "15px",
                          background: "transparent",
                          border: "none",
                          fontSize: "24px",
                          fontWeight: "bold",
                          cursor: "pointer",
                        }}
                        aria-label="Close"
                      >
                        &times;
                      </button>
                    </div>

                    <div
                      style={{
                        padding: "20px 30px",
                        overflowY: "auto",
                        flexGrow: 1,
                      }}
                    >
                      <DataTable
                        // title="Student List"
                        columns={[
                          {
                            name: "Sl. No",
                            cell: (row, index) =>
                              (currentPage - 1) * perPage + index + 1,
                            width: "80px",
                          },
                          {
                            name: "Student Name",
                            selector: (row) => row.candidatE_NAME,
                            sortable: true,
                            width: "270px",
                          },
                          {
                            name: "Gender",
                            selector: (row) => row.gender,
                            // sortable: true,
                            width: "100px",
                          },
                          {
                            name: "Attempt",
                            selector: (row) => row.attempt,
                            sortable: true,
                          },
                          {
                            name: "Board",
                            selector: (row) => row.boarD_NAME,
                            width: "90px",
                          },
                          {
                            name: "Caste",
                            selector: (row) => row.castE_NAME,
                            width: "100px",
                          },
                          {
                            name: "Category",
                            selector: (row) =>
                              row.studenT_EXAM_CATEGORY_DESCRIPTION,
                            width: "120px",
                          },
                          {
                            name: "Registration Fees",
                            selector: (row) => row.exaM_FEES,
                            right: true,
                            width: "150px",
                          },
                          {
                            name: "Late Fees",
                            selector: (row) => row.latE_FEE,
                            right: true,
                            width: "120px",
                          },
                        ]}
                        data={modalData}
                        dense
                        striped
                        pagination
                        responsive
                        highlightOnHover
                        paginationPerPage={100}
                        customStyles={customStyles}
                        paginationRowsPerPageOptions={[10, 20, 50, 100]}
                        onChangePage={(page) => setCurrentPage(page)}
                        onChangeRowsPerPage={(newPerPage, page) => {
                          setPerPage(newPerPage);
                          setCurrentPage(page);
                        }}
                      />

                      {/* Total */}
                      <div className="text-end fw-bold mt-4">
                        Total Fees:{" "}
                        {modalData.reduce(
                          (total, student) =>
                            total +
                            (parseFloat(student.exaM_FEES) || 0) +
                            (parseFloat(student.latE_FEE) || 0),
                          0
                        )}
                      </div>
                    </div>

                    {/* Modal Footer */}
                    <div
                      style={{
                        padding: "15px 30px",
                        borderTop: "1px solid #ddd",
                        textAlign: "right",
                      }}
                    >
                      <button
                        className="btn btn-info btn-sm"
                        onClick={generatePdf}
                      >
                        <i className="fa fa-print"></i> Print Annexure
                      </button>
                    </div>
                  </motion.div>
                </motion.div>
              )}
            </AnimatePresence>
            <AnimatePresence>
              {showModal2 && (
                <motion.div
                  className="modal-backdrop"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100vw",
                    height: "100vh",
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    backdropFilter: "blur(8px)",
                    WebkitBackdropFilter: "blur(8px)",
                    zIndex: 1100,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <motion.div
                    initial={{ scale: 0.8, opacity: 0 }}
                    animate={{ scale: 1, opacity: 1 }}
                    exit={{ scale: 0.8, opacity: 0 }}
                    transition={{ duration: 0.3 }}
                    style={{
                      background: "#fff",
                      borderRadius: "12px",
                      width: "95%",
                      maxWidth: "600px",
                      position: "relative",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <div
                      className="bg-primary"
                      style={{
                        color: "white",
                        padding: "15px 30px",
                        borderBottom: "1px solid #ddd",
                        fontWeight: "bold",
                        fontSize: "18px",
                        position: "relative",
                      }}
                    >
                      <h5 className="modal-title">Pay through NEFT / RTGS</h5>
                      <button
                        type="button"
                        onClick={() => {
                          setShowModal2(false);
                        }}
                        style={{
                          color: "white",
                          position: "absolute",
                          top: "10px",
                          right: "15px",
                          background: "transparent",
                          border: "none",
                          fontSize: "24px",
                          fontWeight: "bold",
                          cursor: "pointer",
                        }}
                        aria-label="Close"
                      >
                        &times;
                      </button>
                    </div>

                    <div style={{ padding: "20px 30px", flexGrow: 1 }}>
                      <table className="table table-hover table-bordered">
                        <tbody>
                          <tr>
                            <td style={{ width: "40%" }}>
                              UTR / General No. :{" "}
                              <span className="text-danger">*</span>
                            </td>
                            <td>
                              <input
                                type="text"
                                name="utrNumber"
                                className="form-control form-control-xs"
                                value={formData.utrNumber.toUpperCase()}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  if (!value.includes("|")) {
                                    handleInputChange(e);
                                  }
                                }}
                              />
                            </td>
                          </tr>
                          <tr>
                            <td>
                              Payment Date :{" "}
                              <span className="text-danger">*</span>
                            </td>
                            <td>
                              <DatePicker
                                selected={
                                  formData.paymentDate
                                    ? new Date(formData.paymentDate)
                                    : null
                                }
                                onChange={(date) =>
                                  setFormData({
                                    ...formData,
                                    paymentDate: date,
                                  })
                                }
                                dateFormat="dd-MM-yyyy"
                                className="form-control form-control-xs"
                                placeholderText="dd-mm-yyyy"
                                onKeyDown={(e) => e.preventDefault()}
                                maxDate={new Date()}
                                minDate={regstartdatefinal}
                                showYearDropdown
                                scrollableYearDropdown
                                yearDropdownItemNumber={60}
                              />
                            </td>
                          </tr>
                          <tr>
                            <td>
                              Bank Name : <span className="text-danger">*</span>
                            </td>
                            <td>
                              <input
                                type="text"
                                name="bankName"
                                className="form-control form-control-xs"
                                value={formData.bankName.toUpperCase()}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  if (!value.includes("|")) {
                                    handleInputChange(e);
                                  }
                                }}
                              />
                            </td>
                          </tr>
                          <tr>
                            <td>
                              Amount : <span className="text-danger">*</span>
                            </td>
                            <td>
                              <input
                                type="text"
                                name="amount"
                                className="form-control form-control-xs text-right"
                                disabled
                                value={`Rs. ${selectedExamFees}.00`}
                              />
                            </td>
                          </tr>
                          <tr>
                            <td>
                              Upload Payment Proof:{" "}
                              <span className="text-danger">*</span>
                            </td>
                            <td>
                              <div style={{ marginBottom: "3px" }}>
                                <b
                                  style={{
                                    fontSize: "11px",
                                  }}
                                >
                                  ( Max Size : 10KB to 100KB, Format : JPG, JPEG
                                  & PNG )
                                </b>
                              </div>
                              <input
                                type="file"
                                name="document"
                                accept=".jpg,.jpeg,.png"
                                className="form-control form-control-xs"
                                onChange={handleInputChange}
                                ref={fileInputRef} // Add ref to file input
                              />
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div
                      style={{
                        padding: "15px 30px",
                        borderTop: "1px solid #ddd",
                        textAlign: "right",
                      }}
                    >
                      <button
                        className="btn btn-primary btn-sm"
                        onClick={handleSubmit}
                      >
                        <i className="fa fa-save"></i> Submit
                      </button>
                    </div>
                  </motion.div>
                </motion.div>
              )}
            </AnimatePresence>
            <div
              className="modal fade"
              id="pdfModal"
              role="dialog"
              tabIndex="-1"
            >
              <div className="modal-dialog modal-xl">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">Challan PDF Preview</h5>
                    <button
                      type="button"
                      className="btn-close"
                      onClick={closeModal2}
                    ></button>
                  </div>
                  <div className="modal-body">
                    <iframe
                      ref={iframeRef}
                      width="100%"
                      height="500px"
                      style={{ border: "none" }}
                    ></iframe>
                  </div>
                  <div className="modal-footer">
                    <button className="btn btn-secondary" onClick={closeModal2}>
                      Close
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <Footer12 />
          </div>
        </div>
      </div>
    </>
  );
}

export default Challanstatus12;
